// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"2b1a33f4","667":"fe372c29","977":"aa96d1ad"}[chunkId] + ".chunk.js";
};